/** ============================================================================
 * common
 *
 * @version   1.0.0
 * @author    Sam Rankin <srankin@riester.com>
 * @copyright 2022 RIESTER
 * ========================================================================== */

import { isEmpty, isReduced, listen } from '../../utils';
import choices from '../../vendors/choices';
export default {
	name: 'common',
	initTooltips() {
		var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
		tooltipTriggerList.map(function (tooltipTriggerEl) {
			return new bootstrap.Tooltip(tooltipTriggerEl);
		});
	},
	initLocationDropdown() {
		var locationDropdownList = [].slice.call(document.querySelectorAll('.location-wrapper > .dropdown'));
		locationDropdownList.map(function (locationDropdownEl) {
			var closeBtn = locationDropdownEl.querySelector('.close-location-form');

			listen(
				closeBtn,
				'click',
				(event) => {
					let self = event.target;

					// Move up through the ancestors of the current link until we hit .nav-menu.
					while (!self.classList.contains('dropdown')) {
						self = self.parentNode;
					}
					let toggle = self.querySelector('.dropdown-toggle');
					// self = self.previousSibling;
					toggle = bootstrap.Dropdown.getOrCreateInstance(toggle);

					toggle.hide();
				},
				true,
				true
			);
		});
	},
	initAccordions() {
		const collapseToggleList = document.querySelectorAll('.close-all');
		[...collapseToggleList].map((collapseEl) => {
			listen(
				collapseEl,
				'click',
				(event) => {
					let el = event.target;
					// Move up through the ancestors of the current link until we hit .nav-menu.
					while (!el.classList.contains('close-all')) {
						el = el.parentNode;
					}
					const targetId = el.getAttribute('aria-controls');
					if (!isEmpty(targetId)) {
						const target = document.getElementById(targetId);

						if (!isEmpty(target)) {
							let accordionPanelsList = target.querySelectorAll('.accordion-body');
							[...accordionPanelsList].map((panelEl) => {
								let panel = bootstrap.Collapse.getOrCreateInstance(panelEl, {
									toggle: false,
								});
								panel.hide();
							});
						}
					}
				},
				true,
				true
			);
		});
		const expandToggleList = document.querySelectorAll('.expand-all');
		[...expandToggleList].map((expandEl) => {
			listen(
				expandEl,
				'click',
				(event) => {
					let el = event.target;
					// Move up through the ancestors of the current link until we hit .nav-menu.
					while (!el.classList.contains('expand-all')) {
						el = el.parentNode;
					}
					const targetId = el.getAttribute('aria-controls');
					if (!isEmpty(targetId)) {
						const target = document.getElementById(targetId);

						if (!isEmpty(target)) {
							let accordionPanelsList = target.querySelectorAll('.accordion-body');
							[...accordionPanelsList].map((panelEl) => {
								let panel = bootstrap.Collapse.getOrCreateInstance(panelEl, {
									toggle: false,
								});

								if (!panelEl.classList.contains('show')) {
									panel.show();
								}
							});
						}
					}
				},
				true,
				true
			);
		});
	},
	initAnimations() {
		if (!isReduced) {
			AOS.init({
				disable: 'mobile',
				easing: 'ease-out-quart',
				once: true,
				anchorPlacement: 'top-center',
			});
		}
	},

	/**
	 * Description placeholder
	 * @date 3/9/2023 - 5:29:53 PM
	 *
	 * @param {*} selectInputs
	 */
	initChoices(selectInputs) {
		if (selectInputs.length > 0) {
			selectInputs.forEach(function (input) {
				choices(input);
			});
		}
	},
	resize() {},
	init() {
		$('.sticky').stick_in_parent(); //eslint-disable-line
		this.initAnimations();
		// this.initChoices();
	},
	finalize() {
		const selectInputs = document.querySelectorAll('select:not(#login-select)');
		this.initChoices(selectInputs);
		this.initTooltips();
		this.initLocationDropdown();
		this.initAccordions();

		iFrameResize({}, '.iframe-resize'); //eslint-disable-line
	},
};
